webpackJsonp([112254247690605],{

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-image: url(', ');\n  padding: 25px;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-image: url(', ');\n  padding: 25px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Navigation = __webpack_require__(70);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _header = __webpack_require__(93);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainHeader = function (_React$Component) {
	  _inherits(MainHeader, _React$Component);
	
	  function MainHeader() {
	    _classCallCheck(this, MainHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainHeader.prototype.render = function render() {
	    return _react2.default.createElement(
	      SiteContainer,
	      null,
	      _react2.default.createElement(_Navigation2.default, null)
	    );
	  };
	
	  return MainHeader;
	}(_react2.default.Component);
	
	var SiteContainer = _styledComponents2.default.div(_templateObject, _header2.default);
	
	exports.default = MainHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  margin: 0;\n'], ['\n  padding: ', ';\n  margin: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  margin: 0;\n'], ['\n  list-style: none;\n  margin: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  list-style: none;\n'], ['\n  list-style: none;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  font-weight: 200;\n  color: black;\n  margin: 0;\n  line-height: 1.5;\n  border-bottom: 1px solid transparent;\n  text-decoration: none;\n'], ['\n  display: inline-block;\n  font-weight: 200;\n  color: black;\n  margin: 0;\n  line-height: 1.5;\n  border-bottom: 1px solid transparent;\n  text-decoration: none;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n'], ['\n  margin: 0;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  a:hover {\n    border-bottom: 1px solid black;\n  }\n'], ['\n  margin: 0;\n  a:hover {\n    border-bottom: 1px solid black;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  font-weight: ', ';\n  font-size: ', ';\n  color: ', ';\n'], ['\n  font-weight: ', ';\n  font-size: ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(63);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	/* eslint react/no-array-index-key: "off" */
	
	var Links = function Links(_ref) {
	  var entries = _ref.entries;
	  return _react2.default.createElement(
	    StyledLinkList,
	    null,
	    entries.map(function (_ref2, key) {
	      var entry = _ref2.entry;
	      return _react2.default.createElement(
	        EntryListItem,
	        { key: key },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: entry.childMarkdownRemark.fields.slug },
	          _react2.default.createElement(
	            EntryTitle,
	            null,
	            entry.childMarkdownRemark.frontmatter.title
	          )
	        )
	      );
	    })
	  );
	};
	
	var ChapterList = function ChapterList(_ref3) {
	  var chapters = _ref3.chapters,
	      entries = _ref3.entries,
	      title = _ref3.title,
	      _ref3$level = _ref3.level,
	      level = _ref3$level === undefined ? 0 : _ref3$level;
	  return _react2.default.createElement(
	    StyledChapterList,
	    null,
	    title && _react2.default.createElement(
	      ChapterListItem,
	      { key: '' + title + level },
	      _react2.default.createElement(
	        ChapterTitle,
	        { level: level },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      ChapterListItem,
	      null,
	      entries && _react2.default.createElement(Links, { entries: entries })
	    ),
	    _react2.default.createElement(
	      ChapterListItem,
	      null,
	      chapters && chapters.map(function (chapter, index) {
	        return _react2.default.createElement(ChapterList, _extends({}, chapter, { level: level + 1, key: '' + index }));
	      })
	    )
	  );
	};
	
	var TableOfContents = function TableOfContents(_ref4) {
	  var chapters = _ref4.chapters;
	  return _react2.default.createElement(
	    TOCWrapper,
	    null,
	    chapters.map(function (chapter, index) {
	      return _react2.default.createElement(ChapterList, _extends({}, chapter, { key: index }));
	    })
	  );
	};
	
	exports.default = TableOfContents;
	
	
	var TOCWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.sitePadding;
	});
	
	var StyledChapterList = _styledComponents2.default.ol(_templateObject2);
	
	var StyledLinkList = _styledComponents2.default.ol(_templateObject3);
	
	var EntryTitle = _styledComponents2.default.h6(_templateObject4);
	
	var ChapterListItem = _styledComponents2.default.li(_templateObject5);
	
	var EntryListItem = _styledComponents2.default.li(_templateObject6);
	
	var ChapterTitle = _styledComponents2.default.h5(_templateObject7, function (_ref5) {
	  var level = _ref5.level;
	
	  switch (level % 3) {
	    case 1:
	      return '600';
	    case 2:
	      return '400';
	    default:
	      return '200';
	  }
	}, function (_ref6) {
	  var level = _ref6.level;
	
	  switch (level % 3) {
	    case 1:
	      return '2.2rem';
	    case 2:
	      return '1.8rem';
	    default:
	      return '2.8rem';
	  }
	}, function (_ref7) {
	  var level = _ref7.level,
	      theme = _ref7.theme;
	
	  switch (level % 3) {
	    case 1:
	      return 'black';
	    case 2:
	      return theme.accent;
	    default:
	      return theme.brand;
	  }
	});
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      image = postMeta.cover;
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === '/' ? '' : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      '@context': 'http://schema.org',
	      '@type': 'WebSite',
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ''
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            '@id': postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        '@context': 'http://schema.org',
	        '@type': 'BlogPosting',
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : '',
	        headline: title,
	        image: {
	          '@type': 'ImageObject',
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', {
	        property: 'fb:app_id',
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:creator',
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100vh;\n  display: grid;\n  grid-template-rows: 75px 1fr;\n  grid-template-columns: 300px 1fr;\n\n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    height: inherit;\n  }\n'], ['\n  height: 100vh;\n  display: grid;\n  grid-template-rows: 75px 1fr;\n  grid-template-columns: 300px 1fr;\n\n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    height: inherit;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ', ';\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n\n  & > div {\n    max-width: ', ';\n    margin: auto;\n  }\n\n  & > h1 {\n    color: ', ';\n  }\n'], ['\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ', ';\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n\n  & > div {\n    max-width: ', ';\n    margin: auto;\n  }\n\n  & > h1 {\n    color: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  grid-column: 1 / 3;\n  grid-row: 1 / 2;\n  z-index: 2;\n  @media screen and (max-width: 600px) {\n    order: 1;\n  }\n'], ['\n  grid-column: 1 / 3;\n  grid-row: 1 / 2;\n  z-index: 2;\n  @media screen and (max-width: 600px) {\n    order: 1;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  grid-column: 1 / 2;\n  grid-row: 2 / 3;\n  background: ', ';\n  overflow: scroll;\n  @media screen and (max-width: 600px) {\n    order: 3;\n    overflow: inherit;\n  }\n'], ['\n  grid-column: 1 / 2;\n  grid-row: 2 / 3;\n  background: ', ';\n  overflow: scroll;\n  @media screen and (max-width: 600px) {\n    order: 3;\n    overflow: inherit;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SEO = __webpack_require__(54);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Header = __webpack_require__(53);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _TableOfContents = __webpack_require__(254);
	
	var _TableOfContents2 = _interopRequireDefault(_TableOfContents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LessonTemplate = function (_React$Component) {
	  _inherits(LessonTemplate, _React$Component);
	
	  function LessonTemplate() {
	    _classCallCheck(this, LessonTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LessonTemplate.prototype.render = function render() {
	    var slug = this.props.pathContext.slug;
	
	    var postNode = this.props.data.postBySlug;
	    var post = postNode.frontmatter;
	    if (!post.id) {
	      post.id = slug;
	    }
	    if (!post.id) {
	      post.category_id = _SiteConfig2.default.postDefaultCategoryID;
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          post.title + ' | ' + _SiteConfig2.default.siteTitle
	        )
	      ),
	      _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	      _react2.default.createElement(
	        BodyGrid,
	        null,
	        _react2.default.createElement(
	          HeaderContainer,
	          null,
	          _react2.default.createElement(_Header2.default, { location: this.props.location })
	        ),
	        _react2.default.createElement(
	          ToCContainer,
	          null,
	          _react2.default.createElement(_TableOfContents2.default, {
	            chapters: this.props.data.tableOfContents.chapters
	          })
	        ),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              post.title
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: postNode.html } })
	          )
	        )
	      )
	    );
	  };
	
	  return LessonTemplate;
	}(_react2.default.Component);
	
	exports.default = LessonTemplate;
	
	
	var BodyGrid = _styledComponents2.default.div(_templateObject);
	
	var BodyContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.accentDark;
	});
	
	var HeaderContainer = _styledComponents2.default.div(_templateObject3);
	
	var ToCContainer = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.lightGrey;
	});
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-lesson-jsx-07534edb7228c3f4b20b.js